<div class="row action-toolbar">
    <div class="col-12">
        <form class="form-inline">
            <wj-multi-select
                style="width: 350px"
                [itemsSource]="activeJobsMap()"
                [placeholder]="'Choose Jobs'"
                [selectedValuePath]="'value'"
                [displayMemberPath]="'display'"
                [checkedMemberPath]="'selected'"
                [showSelectAllCheckbox]="true"
                [showFilterInput]="true"
                [maxHeaderItems]="1"
                (checkedItemsChanged)="refresh()"
            ></wj-multi-select>
        </form>
    </div>
</div>
<div class="row">
    <div class="col-12">
        @if (costChangesChartData) {
            <wj-flex-chart
                appAutoSize
                [itemsSource]="costChangesChartData.points"
                [bindingX]="'label'"
                [chartType]="costChangesChartData.chartType"
                [header]="costChangesChartData.title"
                [legendToggle]="true"
            >
                <wj-flex-chart-legend [position]="'Right'"></wj-flex-chart-legend>
                <wj-flex-chart-axis [wjProperty]="'axisY'" [title]="'Cost Change'" [format]="'C0'"></wj-flex-chart-axis>
                <wj-flex-chart-series *ngFor="let serie of costChangesChartData.series" [binding]="serie.binding" [name]="serie.name">
                </wj-flex-chart-series>
            </wj-flex-chart>
        }
    </div>
</div>
